import layout from './lib/layout'

export default {
  layout
}
